
import { Box, alpha, useTheme } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import EntityAvatar from 'theme/components/Avatar/EntityAvatar'
import { DensityStyleTypes } from '../../../../types'

interface RenderUserProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const RenderUserCell: React.FC<RenderUserProps> = ({ params, densityStyles }) => {
  const theme = useTheme()
  const { owner } = params?.row ?? {}
  return (
    <>
      {owner ? (
        // <UserImageComponent
        //   imageUrl={owner.image_512}
        //   width={densityStyles.avatarSize}
        //   height={densityStyles.avatarSize}
        // />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: densityStyles.padding,
          }}
        >
          <EntityAvatar
            name={owner?.name ?? null}
            photoUrl={owner.image_512}
            size={densityStyles.size}
            showName={false}
            tooltip
          />
        </Box>
      ) : (
        <Box
          sx={{
            width: densityStyles.avatarSize,
            height: densityStyles.avatarSize,
            borderRadius: '50%',
            backgroundColor: alpha(theme.palette.text.primary, 0.15),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: alpha(theme.palette.text.primary, 0.6),
            fontSize: densityStyles.fontSize,
          }}
        >
          ?
        </Box>
      )}
    </>
  )
}
export default RenderUserCell
